// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {faFacebookSquare, faInstagram, faLinkedin} from '@fortawesome/free-brands-svg-icons'
import {faHeart, faSyncAlt, faArrowCircleDown, faArrowUp} from '@fortawesome/free-solid-svg-icons'
import vueHeadful from 'vue-headful'
import VueClipboard from 'vue-clipboard2'
import VueAnalytics from 'vue-ua'

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

// Setup Vue Analytics
Vue.use(VueAnalytics, {
  appName: 'Itchyfeet',
  appVersion: '1.0.0',
  trackingId: 'UA-126559311-1',
  vueRouter: router,
  trackPage: true
})

// Setup Icons
Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(faFacebookSquare, faInstagram, faLinkedin, faHeart, faSyncAlt, faArrowCircleDown, faArrowUp)

// Setup headful for title, and other metadata
Vue.component('vue-headful', vueHeadful)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js